import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, from, map, Observable, of, switchMap, take } from 'rxjs';

import { SDK } from '@plugins/middleware-sdk';
import { Dict } from '@plugins/shared/types';
import { ProfileDataService } from '@plugins/userdetails-client';

import { stripCustomPropertyPrefix } from '../utils/autofill-profile-fields';

export const userProfileFieldsResolver: ResolveFn<Observable<Dict>> = () => {
  const sdk = inject(SDK);
  const profileDataService = inject(ProfileDataService);

  return from(sdk.isFeatureEnabled('userpicker')).pipe(
    switchMap((available) => {
      if (available) {
        return profileDataService.getProfileFull().pipe(
          map((profile) => {
            return Object.entries(profile).reduce<Dict>((acc, [prop, val]) => {
              acc[stripCustomPropertyPrefix(prop)] = val;
              return acc;
            }, {});
          }),
        );
      }
      return of({});
    }),
    catchError(() => of({})),
    take(1),
  );
};
